// eslint-disable-next-line
import util from 'util';


import * as PortalApi from '../PortalApi';
// import * as coreSelectors from './selectors';

/*
 * Get the user record
 */
export function queryUser(successHandler, errorHandler) {
  PortalApi.call('/api/me', { method: 'get' }, successHandler, errorHandler);
}

/*
 * Change the access PIN
 */
export function changeAccessPin(successHandler, errorHandler, accessPin) {
  let form = PortalApi.makeForm({accessPin});
  PortalApi.call('/api/me/accessPin',
                 {
                   method: 'post',
                   body : form
                 },
                 successHandler, errorHandler);
}

/*
 * Acknowledge usage notification
 */
export function ackNotification(successHandler, errorHandler, usageNotificationId) {
  let form = PortalApi.makeForm({usageNotificationId});
  PortalApi.call('/api/me/ackNotification',
                 {
                   method: 'post',
                   body : form
                 },
                 successHandler, errorHandler);
}

/*
 * Create a new session from an identity key
 */
export function createSession(successHandler, errorHandler, identityKey) {
  let form = PortalApi.makeForm({identityKey});
  PortalApi.call('/api/session',
               {
                 method: 'post',
                 body : form,
               },
               successHandler, errorHandler);
}

/*
 * Completely log out of the device
 */
export function logout(successHandler, errorHandler) {
  PortalApi.call('/api/me/logout',
               {
                 method: 'post',
               },
               successHandler, errorHandler);
}

/*
 * Send an SMS two factor code for the current session
 */
export function sendTwoFactor(successHandler, errorHandler, email) {
  let url = '/api/me/twoFactor/send/sms';
  if (email) {
    url = '/api/me/twoFactor/send/email';
  }
  PortalApi.call(url,
               {
                 method: 'post',
               },
               successHandler, errorHandler);
}

/*
 * Verify a two factor code
 */
export function verifyTwoFactor(successHandler, errorHandler, twoFactorCode) {
  let form = PortalApi.makeForm({twoFactorCode});  
  PortalApi.call('/api/me/twoFactor/verify',
               {
                 method : 'post',
                 body : form,
               },
               successHandler, errorHandler);
}

/*
 * Change the password
 */
export function changePassword(successHandler, errorHandler, passwordChangeKey, password) {
  let form = PortalApi.makeForm({passwordChangeKey, password});
  PortalApi.call('/api/me/password',
               {
                 method : 'post',
                 body : form,
               },
               successHandler, errorHandler);
}


/*
 * Send a forgot password reset code
 */
export function sendPasswordResetCode(successHandler, errorHandler, mobile, email) {
  let form = PortalApi.makeForm({mobile, email});
  PortalApi.call('/api/authenticate/forgotPassword/sendCode',
               {
                 method : 'post',
                 body : form,
               },
               successHandler, errorHandler);
}

/*
 * Reset the password with the code
 */
export function resetPassword(successHandler, errorHandler, mobile, email, resetCode) {
  let form = PortalApi.makeForm({mobile, email, resetCode});
  PortalApi.call('/api/authenticate/forgotPassword/resetPassword',
               {
                 method : 'post',
                 body : form,
               },
               successHandler, errorHandler);
}

/*
 * Get the public key for Web API 
 */
export function getWebApiPublicKey(successHandler, errorHandler) {
  PortalApi.call('/api/publicKey/webApi', {}, 
                 successHandler, errorHandler);
}

/*
 * Register a Web push device
 */
export function registerPushDevice(successHandler, errorHandler, endpoint, clientKey, clientAuth) {
  let description = window.navigator.userAgent;
  let form = PortalApi.makeForm({systemType : 'WEBPUSH', description, endpoint, clientKey, clientAuth});
  PortalApi.call('/api/devices', 
                 {
                   method : 'post',
                   body : form,
                 },
                 successHandler, errorHandler);
}


/*
 * Get the api info
 */
export function getApiInfo(successHandler, errorHandler) {
  PortalApi.call('/api/status', {}, 
                 successHandler, errorHandler);
}
